import { Directive, inject, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { Resource } from '@models/resource';
import { Users } from '@models/user';
import { Pundit } from '@services/pundit';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[lvPermit]'
})
export class PermitDirective {
  private userService = inject(Users);
  private templateRef = inject(TemplateRef<any>);
  private viewContainer = inject(ViewContainerRef);

  @Input() set lvPermit(tuple: [string, string | Resource]) {
    const [permission, resource] = tuple;
    this.userService
      .currentUser()
      .asPromise()
      .then((user) => {
        const policy = Pundit.policy(user, resource);
        if (policy[permission]()) {
          this.viewContainer.createEmbeddedView(this.templateRef);
        }
      });
  }
}
